// Which door the client came in through. Marketing sends traffic to /live; everyone
// else lands on the root. The backend stamps the HubSpot NTQ record's ntq_version from
// this (mrkt vs v2), so it rides along on every write that can create or update it.
export function entryFromPath(pathname) {
  const raw = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  const p = (raw || '').toLowerCase();
  return /^\/live\/?$/.test(p) ? 'live' : null;
}

// The PompaBooking embed route (NTAI-EMB-03): /embed renders the flow for an iframe on
// PB's prep page, and only when the deploy-time config turns it on.
export function isEmbedPath(pathname) {
  const raw = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  // Case-sensitive and exact, like the CloudFront behaviors that give /embed and /embed/
  // their frame-ancestors header (CloudFront path patterns are case-sensitive).
  return /^\/embed\/?$/.test(raw || '');
}
